module.exports = __webpack_public_path__ + "static/grid-holy-08e8dd1c0ead3bbf6c2c35878ce66ca2.png";